import { LanguageConstant } from './constants';

export const LanguageActions = {
  setLanguage,
};

function setLanguage(culture) {
  return (dispatch) => {
    dispatch(changeLanguage(culture));
  };

  function changeLanguage(data) {
    const iframe = document.getElementById('ma11ly-widget-iframe');
    iframe?.contentWindow?.postMessage({ type: 'ma11y_config_setLanguage', payload: { currentLanguage: data?.slice(0, 2) } }, '*');

    return { type: LanguageConstant.CHANGE_LANGUAGE, payload: data };
  }
}
